import { Button } from '../../../../common/button';
import { usePayouts } from '../../../../../store/payouts';
import { ReactComponent as DownloadIcon } from '../../../../../assets/icons/file-download.svg';
import l from '../../../../../lang';
import DialogExportPayoutContacts from './dialog';

const ExportPayoutContacts = () => {
  const { showExportPayoutContacts } = usePayouts();

  return (
    <>
      <DialogExportPayoutContacts />
      <Button
        variant="outlined"
        startIcon={<DownloadIcon className="payout_contacts__download__icon" />}
        className="payout_contacts__download"
        onClick={() => showExportPayoutContacts(true)}
      >
        {l('payoutContacts.downloadHistory')}
      </Button>
    </>
  );
};

export default ExportPayoutContacts;
